import { EditingState, TabsCategories } from '@/store/modules/editing/state';
import { SectionType } from '@/typings/enums/enums';
import { SectionBaseModel } from '@/components/layout/section/SectionBaseModel';
import { MutationTree } from 'vuex';
import { ModelTypes } from '@/typings/types/types';
import { ActiveModelPayload, ContextMenuPayload } from '@/store/modules/editing/types';

export type Mutations<S = EditingState> = {
  setSectionWithGame(state: S, payload: SectionBaseModel): void;
  setNavigatorActiveState(state: S, activeState: boolean): void;
  setNavigatorTabCategory(state: S, activeTab: SectionType): void;
  setSelectedContextItem(state: S, item: ModelTypes): void;
  onShowContextMenu(state: S, payload: ContextMenuPayload): void;
  onHideContextMenu(state: S): void;
  setActiveModel(state: S, payload: ActiveModelPayload): void;
  removeActiveModel(state: S): void;
  setCurrentActiveNavigatorID(state: S): void;
  removeCurrentActiveNavigatorID(state: S): void;
  clearActiveTabCategory(state: S): void;
  setDefaultTabCategory(state: S): void;
  setNavigatorCategories(state: S, categories: TabsCategories[]): void;
  setShowGameSettingsModal(state: S, show: boolean): void;
  setShowLayoutSettingsModal(state: S, show: boolean): void;
};

export const mutations: MutationTree<EditingState> & Mutations = {
  setShowGameSettingsModal: (state, show) => {
    state.showGameSettingsModal = show;
  },
  setShowLayoutSettingsModal: (state, show) => {
    state.showLayoutSettingsModal = show;
  },
  setSectionWithGame: (state, payload) => {
    state.sectionWithGame = payload;
  },
  setNavigatorActiveState: (state, activeState) => {
    state.isNavigatorActive = activeState;
  },
  setNavigatorTabCategory: (state, activeTab) => {
    state.activeTabCategory = activeTab;
  },
  setSelectedContextItem: (state, item) => {
    state.selectedContextItem = item;
  },
  onShowContextMenu: (state, payload) => {
    state.contextXPosition = payload.event ? payload.event.clientX : 0;
    state.contextYPosition = payload.event ? payload.event.clientY : 0;
    if (payload.isActive) {
      state.isContextMenuVisible = true;
      state.selectedContextItem = payload.model;
    }
  },
  onHideContextMenu: (state) => {
    state.isContextMenuVisible = false;
    state.selectedContextItem = undefined;
  },
  setActiveModel: (state, payload) => {
    state.activeModel = payload.model;
    state.activeModel.setEditingActive();

    mutations.setCurrentActiveNavigatorID(state);
  },
  removeActiveModel: (state) => {
    if (state.activeModel?.state.edit) {
      state.activeModel.state.edit.isActive = false;
    }
    state.activeModel = undefined;
    mutations.removeCurrentActiveNavigatorID(state);
  },
  setCurrentActiveNavigatorID: (state) => {
    state.activeNavigatorId = state.activeModel?.state?.id ?? 0;
  },
  removeCurrentActiveNavigatorID: (state) => {
    state.activeNavigatorId = null;
  },
  clearActiveTabCategory: (state) => {
    state.activeTabCategory = undefined;
  },
  setDefaultTabCategory: (state) => {
    state.activeTabCategory = SectionType.SECTION;
  },
  setNavigatorCategories: (state, categories: TabsCategories[]) => {
    state.navigatorCategories = categories;
  }
};
